import { render } from "./FeatuersSection.vue?vue&type=template&id=66bfd542"
import script from "./FeatuersSection.vue?vue&type=script&lang=js"
export * from "./FeatuersSection.vue?vue&type=script&lang=js"

import "./FeatuersSection.vue?vue&type=style&index=0&id=66bfd542&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__